import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'app/shared/service/app-config.service';
import { EntityService } from 'app/shared/service/entity.service';
import { IEntityInfo } from '@briebug/ngrx-auto-entity';
import { map, mergeMap } from 'rxjs/operators';


import { Observable } from 'rxjs';
import { User } from './user.model';

@Injectable()
export class UserService extends EntityService<User> {

    constructor(private _http: HttpClient, private _configService: AppConfigService) {
        super(_http, _configService);
    }
    create(entityInfo: IEntityInfo, entity: User): Observable<User> {
        let user$: Observable<User> = super.create(entityInfo, entity);
        if (entity.groupes && entity.groupes.length > 0) {
            return this.saveUser(user$, entityInfo, entity);
        }
        return user$;
    }
    private saveUser(poste$: Observable<User>, entityInfo: IEntityInfo, entity: User): Observable<User> {
        return poste$.pipe(
            mergeMap(poste => {
                let employeesIds = entity.groupes.map(emp => emp.id);
                return this._http.put<User>(
                    `${this._configService.config.apiUrl}/${this.getEntityUri(entityInfo)}/${poste.id}/groupes`,
                    employeesIds);
            })
        );
    }


    updatePassword(username: string, password: string): Observable<User> {
        const params = new HttpParams()
            .set('username', username)
            .set('password', password);
        return this._http.put<any>(
            `${this._configService.config.apiUrl}/users/update-password`, null,
            { params: params }
        );
    }

    updateProfile(user: User): Observable<User> {
        return this._http.put<User>(
            `${this._configService.config.apiUrl}/users/update-profile`, user
        );
    }

    getEnabledUsers(): Observable<User[]> {
        const url = `${this._configService.config.apiUrl}/users/enabled_users`;
        return this._http.get<User[]>(url, {});
      }
      getUsersByRole(roleId : number): Observable<User[]> {
        const url = `${this._configService.config.apiUrl}/users/by_role/${roleId}`;
        return this._http.get<User[]>(url, {});
      }


    

}